import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Landmark } from 'lucide-react';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const userData = await login(email, password);
      toast.success('Login realizado com sucesso!');
      
      // Redireciona baseado nas permissões
      // Se é vendedor OU tem acesso_vendas mas não é admin -> vai para vendas
      const isVendedorOnly = (userData?.role === 'vendedor' || 
        (userData?.role === 'user' && userData?.acesso_vendas === true));
      
      if (isVendedorOnly && userData?.role !== 'admin') {
        navigate('/vendas');
      } else {
        navigate('/');
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4" style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-full mb-4">
            <Landmark className="h-8 w-8 text-primary" />
          </div>
          <h1 className="text-4xl font-bold font-manrope mb-2">Serraria Guedes</h1>
          <p className="text-muted-foreground">Sistema de Gestão</p>
        </div>

        <Card className="border-border">
          <CardHeader>
            <CardTitle className="font-manrope">Entrar</CardTitle>
            <CardDescription>
              Entre com suas credenciais para acessar o sistema
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  data-testid="email-input"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Senha</Label>
                <Input
                  id="password"
                  type="password"
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  data-testid="password-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full"
                disabled={loading}
                data-testid="submit-button"
              >
                {loading ? 'Carregando...' : 'Entrar'}
              </Button>
            </form>

            <p className="mt-4 text-center text-xs text-muted-foreground">
              Não tem acesso? Contate o administrador.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
